import { combineReducers } from 'redux'
import omit from 'lodash/omit'

import actions from '../actionTypes'
import { COLUMN_SORT_STATES } from '../constants'

function defaultSelected(state = false, action) {
  if (action.type === actions.MAKE_DEFAULT_SELECTED_TRUE) {
    return true
  }

  return state
}

function filterModel(state = {}, action) {
  if (action.type === actions.gridState.REDUCE_FILTER_MODEL) {
    return action.payload.filterModel
  }

  if (action.type === actions.gridState.REMOVE_FILTER_COLUMN) {
    return omit(state, action.payload.colId)
  }

  return state
}

function selectedRow(state = null, action) {
  switch (action.type) {
    case actions.selectedRow.SELECT: {
      return action.payload
    }
    case actions.selectedRow.DESELECT: {
      return null
    }
    default:
      return state
  }
}

const sortedColumnInitialState = {
  name: undefined,
  sortState: COLUMN_SORT_STATES.NONE,
}

function sortedColumn(state = sortedColumnInitialState, action) {
  switch (action.type) {
    case actions.sortedColumn.SORT_ASC: {
      return { name: action.payload, sortState: COLUMN_SORT_STATES.asc }
    }
    case actions.sortedColumn.SORT_DESC: {
      return { name: action.payload, sortState: COLUMN_SORT_STATES.desc }
    }
    case actions.sortedColumn.SORT_NONE: {
      return { name: undefined, sortState: COLUMN_SORT_STATES.NONE }
    }
    default:
      return state
  }
}

export default combineReducers({
  defaultSelected,
  selectedRow,
  sortedColumn,
  filterModel,
})
